import { useIsomorphicLayoutEffect } from './helpers';
import { useObservableInternal } from './internal/use-observable-internal';
export function useLayoutObservable(init, inputs) {
    return useObservableInternal(useIsomorphicLayoutEffect, init, inputs);
}
//# sourceMappingURL=use-layout-observable.js.map